import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 19h5v-1a7.35 7.35 0 1 1 6 0v1h5","key":"svg-0"}]]

const IconOmega = createReactComponent('outline', 'omega', 'Omega', __iconNode);

export default IconOmega;